import { render, staticRenderFns } from "./ItemStructure.vue?vue&type=template&id=e744c2e0&lang=html"
import script from "./ItemStructure.vue?vue&type=script&lang=js"
export * from "./ItemStructure.vue?vue&type=script&lang=js"
import style0 from "./ItemStructure.vue?vue&type=style&index=0&id=e744c2e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports